import { useRef } from 'react';

/** The object a presigned URL points at: the URL without its query (signature, expiry). */
export function objectKey(url: string): string {
  try {
    const u = new URL(url);
    return `${u.origin}${u.pathname}`;
  } catch {
    return url.split(/[?#]/)[0] ?? url;
  }
}

/**
 * Returns the first URL seen for an object and keeps it while only the query changes, so a <video> does not
 * reload (and restart) every time polling brings a freshly signed URL for the same file.
 */
export function useStableUrl(url: string | undefined): string | undefined {
  const ref = useRef<string | undefined>(url);
  if (url === undefined) ref.current = undefined;
  else if (ref.current === undefined || objectKey(ref.current) !== objectKey(url)) ref.current = url;
  return ref.current;
}
